import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import { format } from 'date-fns';
import { Membership } from 'src/models/membership';
import { getDollars } from 'src/utils/currency';

interface Props {
  memberships: Membership[];
  setSelectedMembership: (membership: Membership) => void;
}

const UserMembershipHistory = ({
  memberships,
  setSelectedMembership
}: Props) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Start Date</TableCell>
              <TableCell align="left">End Date</TableCell>
              <TableCell align="left">Provider Status</TableCell>
              <TableCell align="left">Provider</TableCell>
              <TableCell align="left">Period</TableCell>
              <TableCell align="left">Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {memberships.map((row) => (
              <TableRow
                key={row.id}
                onClick={() => {
                  setSelectedMembership(row);
                }}
                sx={{ cursor: 'pointer' }}
              >
                <TableCell align="left">{row.id}</TableCell>
                <TableCell align="left">
                  {format(row.startDate, 'MMM dd, yyyy')}
                </TableCell>
                <TableCell align="left">
                  {format(row.subscription.updated, 'MMM dd, yyyy')}
                </TableCell>
                <TableCell align="left">{row.subscription.status}</TableCell>
                <TableCell align="left">{row.subscription.provider}</TableCell>
                <TableCell align="left">{row.subscription.period}</TableCell>
                <TableCell align="left">
                  {`${getDollars(
                    row.subscription.price
                  )} ${row.subscription.currency.toUpperCase()}`}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default UserMembershipHistory;
